<template>
  <div class="flex flex-column padding pointer">
    <div class="flex flex-row tc flex">
      <input 
        id="akkoPlan" 
        class="dn br3 custom" 
        type="radio" 
        :checked="!isPhoneOnly"
        @input="setAkkoPlan"
        name="planToggle"
      >
      <label 
        tabindex="0" 
        for="akkoPlan"
        class="flex items-center justify-center inter f6 tc b buttonUnselected left custom"
      >
        AKKO Plan
      </label>
      <input 
        id="phonePlan" 
        class="dn custom" 
        type="radio" 
        :checked="isPhoneOnly"
        @input="setPhonePlan"
        name="planToggle"
      >
      <label 
        tabindex="0"
        for="phonePlan"
        class="flex items-center justify-center inter f6 tc b buttonUnselected right custom right"
      >
        Phone Only
      </label>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'plan-tabs',
    props: {
      isPhoneOnly: {
        type: Boolean,
        default: false
      },
      setValue: Function
    },
    methods: {
      setAkkoPlan (event) {
        this.setValue(false, event)
      },
      setPhonePlan (event) {
        this.setValue(true, event)
      }
    }
  }
</script>

<style scoped>
  .custom {
    height: 35px;
    margin-bottom: -3px
  }
  .padding { 
    padding-left: 10%;
  }
  .buttonUnselected {
    background-color: white;
    border: 1px solid var(--theme-gray);
    border-bottom-width: 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    color: var(--theme-dark-gray);
    padding-bottom: 3px;
    width: 10em;
    z-index: 0;
    cursor: pointer;
  }
  .left {
    border-right-width: 0;
    background-color: var(--theme-primary);
    border-color: var(--theme-primary);
    color: white;
  }
  .right {
    border-left-width: 0;
    margin-left: -7px;
  }
  input[type=radio]:checked + label {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-width: 1px;
    border-bottom-width: 0;
    z-index: 2;
  }
  input[type=radio]:checked + label.right {
    color: var(--theme-almost-black);
    border-color: var(--theme-almost-black);
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    border-width: 2px;
    border-bottom-width: 0;
  }
  @media (max-width: 400px) {
    .buttonUnselected {
      font-size: 0.6em;
    }
  }
</style>



// WEBPACK FOOTER //
// PlanTabs.vue?f7243a44